import { Address } from '@/types/person';

export const SECURE_SHIPPING_ADDRESS_SLUG = 'secure-shipping-pex-kits';

export interface AddressType {
  id: string;
  name: string;
  slug: string;
}

export interface ValidatedAddress extends Address {
  id: string;
  delivery_point_barcode: string | null;
}
